import { render, staticRenderFns } from "./AdminInterliningsNewScreen.vue?vue&type=template&id=06e738a0&scoped=true&"
import script from "./AdminInterliningsNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminInterliningsNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e738a0",
  null
  
)

export default component.exports